import cardImg from "../../../../../Assets/Images/card-img.png";

const MatrixCard = ({ stats }) => {
  return (
    <div className="card shadow p-3 border-0">
      <p className="hdng-para mb-0 pb-1">Overall Engagement metrics</p>
      <div className="inr-cards py-3">
        <div className="inr-content d-flex justify-content-between pb-4">
          <div className="card-text">
            <div className="card-img">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.studentEnrolled}</p>
              <p className="text-para m-0">Students enrolled with KidEx</p>
            </div>
          </div>
          <div className="card-text">
            <div className="card-img">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.allTimeActiveStudents}</p>
              <p className="text-para m-0">All-time active students</p>
            </div>
          </div>
        </div>
        <div className="inr-content  d-flex justify-content-between">
          <div className="card-text">
            <div className="card-img">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.lastSixTyActiveStudents}</p>
              <p className="text-para m-0">Active students over past 60 days</p>
            </div>
          </div>
          <div className="card-text">
            <div className="card-img">
              <img src={cardImg} alt="cardImg" />
            </div>
            <div className="img-desc">
              <p className="counting m-0">{stats?.lastNinetyActiveStudents}</p>
              <p className="text-para m-0">Active students over past 90 days</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatrixCard;
